import agreement from './index';

export default {
    path: '/home/agreement',
    component: agreement
}